
import { defineComponent, SetupContext } from "vue";

type Props = {
  uploadedImage: String;
};

export default defineComponent({
  name: "Upload",
  props: {
    uploadedImage: {
      type: String,
      default: null,
    },
  },
  emits: ["upload-image", "remove-image"],
  setup(props: Props, context: SetupContext) {
    const SIZE_LIMIT = 10000000; // 10MB

    let file = null;
    let fileErrorMessages = [];

    async function uploadImage(event) {
      const files = event.target.files || event.dataTransfer.files;
      file = files[0];

      if (checkFile(file)) {
        const image = await getBase64(file);
        context.emit("upload-image", image);
      }
    }

    function removeImage() {
      context.emit("remove-image", null);
      file = null;
    }

    function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }

    function checkFile(file) {
      let result = true;
      fileErrorMessages = [];
      // キャンセルしたら処理中断
      if (!file) {
        result = false;
      }
      // jpeg か png 関連ファイル以外は受付けない
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        fileErrorMessages.push(
          "アップロードできるのは jpeg画像ファイル か png画像ファイルのみです。"
        );
        result = false;
      }
      // 上限サイズより大きければ受付けない
      if (SIZE_LIMIT < file.size) {
        fileErrorMessages.push(
          "アップロードできるファイルサイズは10MBまでです。"
        );
        result = false;
      }
      return result;
    }

    return {
      file,
      fileErrorMessages,
      uploadImage,
      removeImage,
    };
  },
});
